import Link from 'next/link';
import {ConditionalWrapper} from '@polarsignals/components';

import Tags from './Tags';
import {slugify} from 'utils/blog';

const BlogPostMetaInfo = ({meta, isMarkdown}) => {
  const authorLinks =
    isMarkdown === true ? meta.authors.map(author => slugify(author)) : meta.authorLinks;

  return (
    <div
      className="col-span-12 mb-8 flex flex-col items-center lg:col-span-2 lg:items-start"
      style={{marginTop: '1.2em'}}
    >
      <div className="mb-0">
        {meta.authors.map((author, index) => (
          <span key={author}>
            {index > 0 && index < meta.authors.length - 1 ? <span className="mr-2">,</span> : null}
            {index > 0 && index === meta.authors.length - 1 ? (
              <span className="mx-2 text-base">&</span>
            ) : null}
            <ConditionalWrapper
              condition={!!authorLinks[index]}
              wrapper={({children}) => (
                <Link href={`/blog/authors/${authorLinks[index] as string}`} className="text-base">
                  {children}
                </Link>
              )}
            >
              {author}
            </ConditionalWrapper>
          </span>
        ))}
      </div>
      <div className="mb-7 text-sm">{meta.date}</div>
      {meta.tags?.length > 0 ? (
        <div className="flex items-start gap-1 lg:flex-col">
          <Tags tags={meta.tags} centerOnMobile={true} isBlogPost={true} />
        </div>
      ) : null}
    </div>
  );
};

export default BlogPostMetaInfo;
